// {
//   "name": "iconic-circle-menu.js",
//   "author": "Arham Web Works"
//   "description": "Copying in any form is strictly prohibited. Any instance of copying will be subject to legal action and accountability under the law."
// }

(() => {
  if (customElements.get('iconic-circle-menu')) {
    return;
  }

  class IconicCircleMenu extends HTMLElement {
    constructor() {
      super();

      this.initCircleMenu = this.initCircleMenu.bind(this);
    }

    connectedCallback() {
      this.initCircleMenu(); // Initialize Swiper when the element is connected

      if (Shopify.designMode) {
        document.addEventListener('shopify:section:unload', this.initCircleMenu);
        document.addEventListener('shopify:section:load', this.initCircleMenu);
      }
    }

    disconnectedCallback() {
      if (Shopify.designMode) {
        document.removeEventListener('shopify:section:unload', this.initCircleMenu);
        document.removeEventListener('shopify:section:load', this.initCircleMenu);
      }
    }

    initCircleMenu() {
      const swiper = new Swiper('.iconic-circle-swiper', {
        speed: 300,
        slidesPerView: "auto",
        breakpoints: {
          320: {
            spaceBetween: 16,
          },
          768: {
            spaceBetween: 16,
          },
          1024: {
            spaceBetween: 16,
          },
        }
      });
    }
  }

  customElements.define('iconic-circle-menu', IconicCircleMenu);
})();
